import { type ITileLayerProps, type IWMSLayerProps } from '@/Root/Types/LayerTypes'
import { getToken } from '@/Libraries/mapbox/token'

const mapBoxOptions = {
  type: 'tile',
  attribution: 'Base layer &copy; <a href="http://mapbox.com/">MapBox</a>',
  options: {
    reuseTiles: true,
    subdomains: ['a', 'b'],
    tileSize: 512,
    zoomOffset: -1
  }

}
function makeMapBoxUrl (ln: string): string {
  return `https://{s}.api.mapbox.com/styles/v1/${ln}/tiles/{z}/{x}/{y}?access_token=${getToken()}`
}

const baseLayers: Array<ITileLayerProps | IWMSLayerProps> = [
  {
    ...mapBoxOptions,
    id: 'mb_bathymetry',
    type: 'tile',
    zIndex: 0,
    isBaseLayer: true,
    url: makeMapBoxUrl('shane-axiom/cknm3veja3cjw17o5axf7c1g2'),
    label: 'Bathymetry'
  },
  {
    id: 'osm',
    type: 'tile',
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    label: 'OpenStreetMap',
    attribution: 'Map data &copy; <a href=http://openstreetmap.org>OpenStreetMap</a> contributors',
    zIndex: 0,
    isBaseLayer: true,
    options: {
      subdomains: ['a', 'b', 'c']
    }
  },
  {
    ...mapBoxOptions,
    id: 'hybrid',
    type: 'tile',
    zIndex: 0,
    isBaseLayer: true,
    url: makeMapBoxUrl('shane-axiom/ck7mgchpc0sgk1iqk78q1wy4w'),
    label: 'Hybrid'
  },
  {
    label: 'Black and White',
    id: 'bw',
    url: '//{s}.data.axds.co/gs/gshhg/wms?bgcolor=0xC0C0C0',
    type: 'wms',
    zIndex: 0,
    isBaseLayer: true,
    options: {
      subdomains: ['30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40']
    },
    params: {
      layers: 'gshhs_solid_bglite_full',
      format: 'image/jpeg',
      transparent: false
    }
  }
]

baseLayers.forEach(l => {
  if ((l.urls == null) && ((l?.options?.subdomains) != null)) {
    if (l.type === undefined || l.type === null) {
      l.type = 'tile'
    }
    l.urls = l.options.subdomains.map(s => {
      return l.url.replace('{s}', String(s))
    })
  }
})

const baseLayersMapped = Object.fromEntries(baseLayers.map(b => [b.id, b]))

export default baseLayers
export { baseLayers }
export { baseLayersMapped }
